<template>
  <div class="timeslot-timeline">
    <!-- <div v-for="hour in hours" :key="hour"> -->
      <div v-for="event in events" :key="+event.datetime" class="event-column">
        <div class="event-cell">
          <div v-for="freeSlot in event.free" :key="+freeSlot" class="event free-event">
            {{ event.datetime.toTimeString().substring(0, 5) }}
          </div>
        </div>

        <div class="event-cell">
          <div v-for="appointment in event.appointments"
          :key="+appointment.id"
          @click="$router.push(`/appointments/${appointment.id}`)"
          :class="`event appointment-event status${appointment.status}`">
            {{ event.datetime.toTimeString().substring(0, 5 )}}
          </div>
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: "TimeslotTimeline",

  props: {
    timeslot: {type: Object, default(){return {}}},
    limits: {type: Object, default(){return {}}},
    freeSlots: {type: Array, default(){return []}},
    appointments: {type: Array, default(){return []}},
  },

  computed: {
    startHour(){
      if (this.limits.start) { return this.limits.start }
      if (this.eventDatetimes.length > 0){
        return   this.events.reduce((acc, event) => Math.min(event.getHour(), acc), 23)
      }
      return 0
    },

    endHour(){
      if (this.limits.end) { return this.limits.end }
      if (this.events.eventDatetimes > 0){
        return   this.events.reduce((acc, event) => Math.min(eventgetHour(), acc), 0)
      }
      return 23
    },

    hours() {
      const hs = [];
      let h;
      for (h = this.startHour; h <= this.endHour; h++){
        hs.push(h);
      }
      return hs
    },

    events(){
      let datetimes = [...this.freeSlots];

      this.appointments.forEach(appointment => {
        datetimes.push(appointment.datetime);
      });

      datetimes.sort();

      datetimes = datetimes.filter((el, index) => {
        return +el != +datetimes[index-1];
      });

      return datetimes.map(datetime => ({
        datetime,
        appointments: this.appointments.filter(appointment => +appointment.datetime === +datetime),
        free: this.freeSlots.filter(slot => +slot === +datetime)
      }))
    },
  },

}
</script>

<style lang="scss">
.timeslot-timeline {
  display: flex;
  flex-wrap: wrap;
}

.event {
  border: 1px solid black;
  border-radius: .25em;
  margin: .2em .2em .2em .2em;
}

.appointment-event.status-1,
.appointment-event.status-2,
.appointment-event.status-10 {
  background-color: gray;
  color: white;
}


.appointment-event.status0 {
  background-color: yellow;
}
.appointment-event.status1 {
  background-color: blue;
}
.appointment-event.status10 {
  background-color: red;
}

.free-event {
  background-color: white;

}
</style>
